import { c as _c } from "react/compiler-runtime";
import { AlertCircle, CircleCheck, CircleQuestionMark, CircleSlash, CircleX, Clock, CircleDotDashed } from "lucide-react";
import { STATUS_COLORS } from "@/components/filters/StatusFilter";
interface StatusIconProps {
  status?: string;
  size?: number;
  strokeWidth?: number;
}
export function StatusIcon(t0) {
  const $ = _c(34);
  const {
    status: t1,
    size: t2,
    strokeWidth
  } = t0;
  const status = t1 === undefined ? "unknown" : t1;
  const size = t2 === undefined ? 6 : t2;
  const t3 = `w-${size} h-${size} flex-shrink-0`;
  let t4;
  if ($[0] !== strokeWidth) {
    t4 = strokeWidth !== undefined ? {
      strokeWidth
    } : {};
    $[0] = strokeWidth;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = {
      className: t3,
      ...t4
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const iconProps = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: STATUS_COLORS.success
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== iconProps) {
    t7 = <CircleCheck {...iconProps} style={t6} />;
    $[6] = iconProps;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      color: STATUS_COLORS.failure
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== iconProps) {
    t9 = <CircleX {...iconProps} style={t8} />;
    $[9] = iconProps;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      color: STATUS_COLORS.cancelled
    };
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== iconProps) {
    t11 = <AlertCircle {...iconProps} style={t10} />;
    $[12] = iconProps;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      color: STATUS_COLORS.in_progress
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== iconProps) {
    t13 = <CircleDotDashed {...iconProps} style={t12} />;
    $[15] = iconProps;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      color: STATUS_COLORS.queued
    };
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== iconProps) {
    t15 = <Clock {...iconProps} style={t14} />;
    $[18] = iconProps;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      color: STATUS_COLORS.unknown
    };
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== iconProps) {
    t17 = <CircleQuestionMark {...iconProps} style={t16} />;
    $[21] = iconProps;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      color: STATUS_COLORS.default
    };
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== iconProps) {
    t19 = <CircleSlash {...iconProps} style={t18} />;
    $[24] = iconProps;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t11 || $[27] !== t13 || $[28] !== t15 || $[29] !== t17 || $[30] !== t19 || $[31] !== t7 || $[32] !== t9) {
    t20 = {
      success: t7,
      failure: t9,
      cancelled: t11,
      in_progress: t13,
      queued: t15,
      unknown: t17,
      default: t19
    };
    $[26] = t11;
    $[27] = t13;
    $[28] = t15;
    $[29] = t17;
    $[30] = t19;
    $[31] = t7;
    $[32] = t9;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  const icons = t20;
  return icons[status as keyof typeof icons] || icons.default;
}